import Backbone from 'backbone';

import {assertAndContinue} from 'Asserts';
import {Molecule} from 'chemistry/molecules/tabs/MoleculeFileState';
import * as SourceConstants from 'constants/SourceConstants';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import BasicInformationPanelView from 'toolbar/shared/BasicInformationPanelView';

export default class MoleculeInformationPanelView extends BasicInformationPanelView<Molecule> {
  initialize(options?: Backbone.ViewOptions<Molecule> | undefined): void {
    super.initialize(options);
  }

  async saveChangesToModel(name: string, folderId: string): Promise<void> {
    const {writable, movable} = this.model.permissions();
    if (writable && this.model.name() !== name) {
      await FileBrowserActions.renameFileWithDataMods(this.model.id, this.isRegistered(), {
        oldName: this.model.name(),
        newName: name,
        parentFolderId: this.model.folder().id,
      });
    } else {
      assertAndContinue(writable, 'User attempted to save changes to a molecule without authorized WRITE');
    }
    if (movable && folderId !== this.model.folder().id) {
      FileBrowserActions.moveItemsWithDataMods([this.model.id], folderId, {
        parentFolderIds: [this.model.folder().id],
        hasRegisteredItems: this.model.folder().source?.sourceType === SourceConstants.REGISTRY_TYPE,
      });
    } else {
      assertAndContinue(
        movable!,
        'User attempted to move a molecule between folders without authorized MOVE'
      );
    }
  }
}
